import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';
import { Topbar, Sidebar, Footer } from './components';
import Container from 'common/Container';
import { pages } from '../navigation';
import { isTnoMediaLabHost, isMediaLabCreatorsPath } from 'utils/tnoMediaLabHost';

const HideOnScroll = ({ children }) => {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

HideOnScroll.propTypes = {
  children: PropTypes.node.isRequired,
};

const Main = ({
  children,
  themeToggler,
  themeMode,
  setThemePalette,
  paletteType,
}) => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const [openSidebar, setOpenSidebar] = useState(false);
  const pathNoTrail = (pathname || '').replace(/\/+$/, '') || '/';
  const isCherrySoftware =
    pathNoTrail === '/cherry-dev' ||
    pathNoTrail === '/cherry-software' ||
    pathNoTrail === '/codigo-lechuza';
  const isCherryWeb =
    pathNoTrail === '/cherry-web' || pathNoTrail === '/cherry-web/anna-sanellia';
  const isPropuestaFarmafer = pathNoTrail === '/propuesta/farmafer';
  const isPropuestaGuomei =
    pathNoTrail === '/propuesta/guomei' ||
    pathNoTrail === '/propuesta/guomei/publicidad';
  const isPropuestaNasiol =
    pathNoTrail === '/propuesta/nasiol' ||
    pathNoTrail === '/propuesta/nasiol/publicidad';
  const isCherrySoftwareCrm =
    pathNoTrail === '/cherry-software-crm' || pathNoTrail === '/codigo-lechuza-crm';
  const isSortilegio = pathNoTrail === '/sortilegio';
  const isTnoMediaLabHome = pathNoTrail === '/' && isTnoMediaLabHost();
  const isMediaLabCreators = isMediaLabCreatorsPath(pathNoTrail);
  const isCherrySoftwareLayout =
    isCherrySoftware ||
    isCherryWeb ||
    isPropuestaFarmafer ||
    isPropuestaGuomei ||
    isPropuestaNasiol ||
    isCherrySoftwareCrm ||
    isSortilegio ||
    isTnoMediaLabHome ||
    isMediaLabCreators;
  const hideHeader =
    pathNoTrail === '/wmautopartes' ||
    pathNoTrail === '/acerca' ||
    isCherrySoftwareLayout;
  const hideFooter =
    pathNoTrail === '/wmautopartes' ||
    pathNoTrail === '/acerca' ||
    pathNoTrail === '/sortilegio' ||
    pathNoTrail === '/cherry-dev' ||
    pathNoTrail === '/cherry-software' ||
    pathNoTrail === '/cherry-web' ||
    pathNoTrail === '/cherry-web/anna-sanellia' ||
    pathNoTrail === '/propuesta/farmafer' ||
    pathNoTrail === '/propuesta/guomei' ||
    pathNoTrail === '/propuesta/guomei/publicidad' ||
    pathNoTrail === '/propuesta/nasiol' ||
    pathNoTrail === '/propuesta/nasiol/publicidad' ||
    pathNoTrail === '/cherry-software-crm' ||
    pathNoTrail === '/codigo-lechuza' ||
    pathNoTrail === '/codigo-lechuza-crm' ||
    isTnoMediaLabHome ||
    isMediaLabCreators;

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  return (
    <div>
      {!hideHeader && (
        <HideOnScroll>
          <AppBar
            position={'fixed'}
            sx={{
              backgroundColor: theme.palette.background.paper,
            }}
            elevation={1}
          >
            <Container
              paddingY={{ xs: 1 / 2, sm: 1 }}
              paddingX={isCherrySoftwareLayout ? { xs: 1.5, sm: 2 } : undefined}
              maxWidth={isCherrySoftwareLayout ? { sm: 720, md: 1280, lg: 1400 } : undefined}
            >
              <Topbar
                onSidebarOpen={handleSidebarOpen}
                themeMode={themeMode}
                themeToggler={themeToggler}
                setThemePalette={setThemePalette}
                paletteType={paletteType}
              />
            </Container>
          </AppBar>
        </HideOnScroll>
      )}
      <Sidebar
        onClose={handleSidebarClose}
        open={openSidebar}
        variant="temporary"
        pages={pages}
      />
      <main>
        {!hideHeader && <Box height={{ xs: 56, sm: 64 }} />}
        {children}
        {!hideFooter && <Divider />}
      </main>
      {!hideFooter && (
        <Container paddingY={4}>
          <Footer themeMode={themeMode} />
        </Container>
      )}
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  themeToggler: PropTypes.func.isRequired,
  themeMode: PropTypes.string.isRequired,
  setThemePalette: PropTypes.func.isRequired,
  paletteType: PropTypes.string.isRequired,
};

export default Main;
